import { combineReducers } from "redux";
import getMenuReducer from "./getMenuReducer";

const menuReducer = combineReducers({
  setMenu: getMenuReducer
});

export default menuReducer;